import { Form, Row, Tabs } from 'antd'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { useAppDispatch } from 'src/app/hooks'
import { i18n, useTranslation } from 'next-i18next'
import { updateIntegrationWhiteLabel } from 'src/features'
import { getDescriptionLanguages } from 'src/core/helpers'
import { CustomCol, FormLabels, CustomTextInput } from 'src/components'
import { IntegrationSettingsFormValues, PosibleLocale } from 'src/core/models'

interface WhiteLabelFormWelcomeTextProps {
  formValues: IntegrationSettingsFormValues
  setFormValues: Function
}

const WhiteLabelFormWelcomeText: React.FC<WhiteLabelFormWelcomeTextProps> = (props) => {
  const { formValues, setFormValues } = props
  const [form] = Form.useForm()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const languages = getDescriptionLanguages(t)
  const { id } = useRouter().query


  const handleChange = (e:  React.ChangeEvent<HTMLInputElement>, locale: PosibleLocale) => {
    const value = e.target.value
    setFormValues({ ...formValues, [`welcoming_text_${locale}`]: value })
    const payload = { [`welcoming_text_${locale}`]: value }
    dispatch(updateIntegrationWhiteLabel(+id, payload))
  }

  useEffect(() => {
    form.setFieldsValue({
      ['welcoming_text_en']: formValues.welcoming_text_en,
      ['welcoming_text_es']: formValues.welcoming_text_es,
      ['welcoming_text_fr']: formValues.welcoming_text_fr,
      ['welcoming_text_ko']: formValues.welcoming_text_ko,
      ['welcoming_text_de']: formValues.welcoming_text_de,
      ['welcoming_text_pt']: formValues.welcoming_text_pt,
      ['welcoming_text_it']: formValues.welcoming_text_it,
    })
  }, [form, formValues])


  return <Form form={form}>
    <Row>
      <CustomCol>
        <FormLabels
          title={t('Whitelabel.WelcomeText')}
          subtitle={t('Whitelabel.AddText')}
        />
      </CustomCol>

      <CustomCol>
        <Tabs defaultActiveKey={i18n.language} size={'small'}>
          {languages.map((item) => <Tabs.TabPane tab={item.label} key={item.locale}>
            <CustomTextInput
              name={`welcoming_text_${item.locale}`}
              placeholder={t('Projects.Form.TextLabel')}
              onChange={(value) => handleChange(value, item.locale)}
            />
          </Tabs.TabPane>)}
        </Tabs>
      </CustomCol>
    </Row>
  </Form>
}

export default WhiteLabelFormWelcomeText
